import * as React from "react";
import { Select } from "../Select/Select";
import { countries } from "./countries";

const nextCountries: typeof countries = [
  { value: "", label: "Select country" },
  ...countries,
];

interface CountrySelectProps extends React.ComponentProps<"select"> {
  errorMessage?: string;
  id?: string;
  label?: string;
}

function CountrySelectInner(
  props: CountrySelectProps,
  forwardedRef: React.ForwardedRef<HTMLSelectElement>
) {
  const { errorMessage, id = "country", label = "Country", ...rest } = props;
  return (
    <Select
      {...rest}
      ref={forwardedRef}
      label={label}
      id={id}
      options={nextCountries}
      errorMessage={errorMessage}
    />
  );
}

const CountrySelect = React.forwardRef<HTMLSelectElement, CountrySelectProps>(
  CountrySelectInner
);

CountrySelect.displayName = "CountrySelect";

export { CountrySelect };
